import { gql } from '@apollo/client';

export default gql`
  mutation processBulkVouchers($serviceNumber: String!, $travelDate: String!) {
    processBulkVouchers(serviceNumber: $serviceNumber, travelDate: $travelDate)
  }
`;
